import classnames from 'classnames'
import * as React from 'react'

import { Tooltip } from 'embed/components/Tooltip'

const InfoSmall = require('embed/components/ApplicationField/info-grey.svg')

const applicationStyles = require('embed/styles/application')
const styles = require('./styles')

export const NoAffect: React.FC = () => (
  <div className={styles.container}>
    <h4 className={applicationStyles.noAffect}>This service is free and will NOT affect your credit score</h4>
    <Tooltip
      overlay="A soft credit report is pulled in accordance with the consumer's written authorization on our site. After reviewing the offer, if a consumer chooses to apply for credit, lending partners or platforms may require a hard pull for processing on their website."
      placement="bottom"
    >
      <span className={classnames(applicationStyles.infoIcon, styles.infoIcon)}>
        <InfoSmall />
      </span>
    </Tooltip>
  </div>
)
